import { Component, OnInit, ViewChild, AfterViewInit, ViewEncapsulation, Input } from '@angular/core';
import { GlobalsService } from '@app/cp/shared/services/globals.service';
import { BaseGridUIComponent } from '@app/cp/shared/base-components/base-grid-ui.component';
import { RelatedJobBus } from '@app/cp/shared/models/RelatedJobBus';
import { ConstructionService } from '@app/cp/shared/services/construction.service';
import { CommonFunctions } from '@app/cp/shared/static/common-functions';
import { aggregateBy } from '@progress/kendo-data-query';
import { FeatureFlagService } from '@app/cp/shared/services/feature-flag.service';

@Component({
    selector: 'contract-post-warranty-jobs',
    templateUrl: './contract-post-warranty-jobs.component.html',
    styleUrls: ['./contract-post-warranty-jobs.component.scss'],
    encapsulation: ViewEncapsulation.None,
    standalone: false
})
export class ContractPostWarrantyJobsComponent extends BaseGridUIComponent<RelatedJobBus, null, ConstructionService> {

    constructor(svc_data: ConstructionService, globals: GlobalsService) {
        super(globals);
        this.svc_data = svc_data;
        this.aggregates = [
            { field: 'totalLaborCosts', aggregate: 'sum' },
            { field: 'totalMatCosts', aggregate: 'sum' },
            { field: 'totalOtherCosts', aggregate: 'sum' },
        ];
    }
    processGridData() {
        if (CommonFunctions.hasArrayElementValue(this.gridData)) {
            this.aggregateResults = aggregateBy(this.gridData, this.aggregates);
        }
    }
}
